import { AlertTriangle } from 'lucide-react'
import PropTypes from 'prop-types'
import { formatAppointmentWindow } from './existingAppointment'

/**
 * CAR-4034 — design "Concise B: warning inside the form". Shown in the Scheduler's New Appointment form once the
 * VIN has an upcoming appointment. A warning only: staff may still save a second appointment.
 */
export const UpcomingAppointmentBanner = ({ appointments, onView }) => {
  if (!appointments?.length) return null
  const [next, ...others] = appointments
  const which = [next.reference_no, formatAppointmentWindow(next)].filter(Boolean).join(' · ')
  return (
    <div
      role='status'
      data-testid='upcoming-appointment-banner'
      className='mb-4 flex items-start gap-3 rounded-lg border border-[#FCD34D] bg-[#FEF9C3] px-3 py-2.5 text-[12px] text-[#713F12]'
    >
      <AlertTriangle className='mt-0.5 h-4 w-4 flex-none text-[#B45309]' />
      <p className='flex-1 leading-5'>
        <span className='font-semibold'>Already scheduled:</span> {which}
        {others.length > 0 && ` (+${others.length} more)`}. Saving adds a second appointment.
      </p>
      <button type='button' onClick={() => onView(next.id)} className='flex-none font-semibold text-[#713F12] underline'>
        View
      </button>
    </div>
  )
}

UpcomingAppointmentBanner.propTypes = {
  appointments: PropTypes.arrayOf(PropTypes.object),
  onView: PropTypes.func.isRequired
}
